const processEvent = require('analytics/processEvent');
const anaConsts = require('analytics/constants');
const deepExtend = require('utils/deepExtend');
const InflatorComps = require('utils/framework/InflateComponents');
const Events = require('utils/framework/Events');
const shouldServiceRun = require('utils/Services').shouldServiceRun;
const store = require('Store');
const watch = require('redux-watch');
const certonaUtils = require('utils/certona.js');
const certonaConstants = require('utils/certonaConstants');
const updateCarousel = require('actions/CertonaActions').updateCarousel;
const Location = require('utils/Location');
const userUtils = require('utils/User');
const skuUtils = require('utils/Sku');
const basketUtils = require('utils/Basket');
const anaUtils = require('analytics/utils');
const localeUtils = require('utils/LanguageLocale');

window.addEventListener(Events.CertonaReady, function() {
    InflatorComps.renderQueue('Certona');
});

function setCertonaObject(prop, value) {
    window.certona[prop] = value;
}

const updateCertonaCustomerId = function(user) {
    if (user && user.profileStatus >= 0) {
        setCertonaObject('customerid', user.profileId);
    }
};

const updateSkuId = function(skuId) {
    setCertonaObject('itemid', skuId);
};

const updateCategoryId = function(categoryId) {
    setCertonaObject('categoryid', categoryId);
};

const updateBasketItems = (basket = {}) => {
    const isUserSubscribed = userUtils.isFlash() || userUtils.isRouge();
    const deltaAmount = basket.remainToFreeShipping;
    const removeCurrency = deltaAmount ? basketUtils.removeCurrency(deltaAmount) : null;
    const shippingAmount = isUserSubscribed ? '0' : removeCurrency || '0';

    setCertonaObject('storeid', basket?.pickupBasket?.storeDetails?.storeId);
    setCertonaObject('itemid', '');
    setCertonaObject('freeshipping', shippingAmount);
    setCertonaObject('isflash', userUtils.isFlash());
    if (basket.itemCount) {
        setCertonaObject('itemid', certonaUtils.getSkuIdsInBasket(basket.products));
    }
};

var pageType;

let getBasket = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.PICK_UP_CART) {
            let basket = store.getState().basket;
            if (basket.isInitialized) {
                updateBasketItems(basket);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'basket')(newVal => {
                        if (newVal.isInitialized) {
                            updateBasketItems(newVal);
                            unsubscribe();
                            resolve();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getProduct = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.PRODUCT) {

            // let { currentProduct = {} } = store.getState().product;
            let currentProduct = store.getState().page.product;
            let skuIdParam = Sephora.Util.getQueryStringParams().skuId;

            // Set itemid with skuid in url or fallback and set with default skuid
            if (skuIdParam) {
                updateSkuId(skuIdParam[0]);
                resolve();
            } else if (currentProduct.currentSku && currentProduct.currentSku.skuId) {
                updateSkuId(currentProduct.currentSku.skuId);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'page.product')(newVal => {
                        if (newVal.currentSku && newVal.currentSku.skuId) {
                            updateSkuId(newVal.currentSku.skuId);
                            unsubscribe();
                            resolve();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getUser = () =>
    new Promise((resolve, reject) => {
        if (certonaUtils.shouldSetCustomerId()) {
            let user = store.getState().user;
            if (user && (user.profileId || user.profileLocale)) {
                updateCertonaCustomerId(user);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'user')(newVal => {
                        if (newVal && (newVal.profileId || newVal.profileStatus === 0)) {
                            updateCertonaCustomerId(newVal);
                            unsubscribe();
                            resolve();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getCategory = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.CATEGORY) {
            const categoryId = store.getState().category.currentCategory;
            if (categoryId) {
                updateCategoryId(categoryId);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'category.currentCategory')(newVal => {
                        if (newVal) {
                            updateCategoryId(newVal);
                            unsubscribe();
                            resolve();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getNullSearchTerm = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.NO_SEARCH) {
            let queryParams = Sephora.Util.getQueryStringParams();
            let keyword = '';
            if (queryParams.keyword && queryParams.keyword.length) {
                keyword = queryParams.keyword[0];
            }
            setCertonaObject('searchTerm', keyword);
            resolve();
        } else {
            resolve();
        }
    });

const updateConfirmationItems = function(order) {
    const orderItems = (order && order.items && order.items.items) || [];
    setCertonaObject(
        'itemid',
        orderItems
            .map(function(item) {
                return item.sku.skuId;
            })
            .join(';')
    );
    setCertonaObject(
        'qty',
        orderItems
            .map(function(item) {
                return item.qty;
            })
            .join(';')
    );

    //iterate through orderItems and create an array with prices of all items
    //with actual cost. do not include free, birthday gift, or reward items.
    let priceArray = [];
    let price;
    let priceInDigits;
    let priceLocale;
    orderItems.forEach(orderItem => {
        if (!skuUtils.isFree(orderItem.sku) && !skuUtils.isBiRewardGwpSample(orderItem.sku)) {
            price = orderItem.salePriceSubtotal ?
                orderItem.salePriceSubtotal : orderItem.listPriceSubtotal;
            priceInDigits = price.replace(/[^\d.]/g, '');
            priceLocale = localeUtils.isCanada() ?
                priceInDigits : anaUtils.convertToUSD(priceInDigits);
            priceArray.push(priceLocale);
        } else {
            priceArray.push('0');
        }
    });
    setCertonaObject('price', priceArray.join(';'));
    let orderTotal = (priceArray.length > 1) ?
        priceArray.reduce((a, b) => parseFloat(a) + parseFloat(b)).toFixed(2) : priceArray[0];
    setCertonaObject('total', orderTotal);
    setCertonaObject('transactionid', order.header.orderId);
};

let getPurchase = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.PURCHASE) {
            let { orderDetails = {} } = store.getState().order;
            if (orderDetails.isInitialized) {
                Sephora.analytics.promises.initialPageLoadFired.then(() => {
                    updateConfirmationItems(orderDetails);
                    resolve();
                });
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'order.orderDetails')(order => {
                        if (order.isInitialized) {
                            Sephora.analytics.promises.initialPageLoadFired.then(() => {
                                updateConfirmationItems(order);
                                unsubscribe();
                                resolve();
                            });
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

const updateContentStoreItems = function(certonaObject) {
    setCertonaObject('categoryid', certonaObject.categoryid);
    setCertonaObject('pagetype', certonaObject.certonaPageType);
};

let getContentPage = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.CONTENT &&
                pageType !== certonaConstants.PAGE_TYPES.HOLIDAY) {
            let productRecs = store.getState().productRecs;
            if (productRecs.certonaObject.certonaPageType) {
                updateContentStoreItems(productRecs.certonaObject);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'productRecs.certonaObject')(certonaObject => {
                        if (certonaObject.certonaPageType) {
                            updateContentStoreItems(certonaObject);
                            unsubscribe();
                            resolve();
                        } else {
                            reject();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getLovesListPage = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.WISH_LIST) {
            let loves = store.getState().loves;
            // loves.shareLink is only defined if store is set up
            if (loves.shareLink) {
                setCertonaObject('itemid', loves.shoppingListIds.join(';'));
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'loves')(newVal => {
                        if (newVal && newVal.shoppingListIds) {
                            setCertonaObject('itemid', newVal.shoppingListIds.join(';'));
                            unsubscribe();
                            resolve();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

let getNthCategoryPage = () =>
    new Promise((resolve, reject) => {
        if (pageType === certonaConstants.PAGE_TYPES.NTH_CATEGORY) {
            let productRecs = store.getState().productRecs;
            if (productRecs.certonaObject.certonaPageType) {
                setCertonaObject('pagetype', productRecs.certonaObject.certonaPageType);
                resolve();
            } else {
                let unsubscribe = store.subscribe(
                    watch(store.getState, 'productRecs.certonaObject')(certonaObject => {
                        if (certonaObject.certonaPageType) {
                            setCertonaObject('pagetype', certonaObject.certonaPageType);
                            unsubscribe();
                            resolve();
                        } else {
                            reject();
                        }
                    }), { ignoreAutoUnsubscribe: true }
                );
            }
        } else {
            resolve();
        }
    });

const getCertona = () =>
    new Promise((resolve, reject) => {
        Events.onLastLoadEvent(window, [Events.CertonaLoaded], resolve);
    });

/**
 * This function is called from Certona only.
 *
 * If you want to re-initiate this call with fresh recommendations from Sephora side,
 * use function: certonaResx.run() //TODO: change to callCertona() if lib is updated
 */
Sephora.certona = function(recs) {
    // Someone is clearing recs with object.assign, I need to save a copy for later
    let savedRecsForAnalytics = deepExtend({}, recs);

    if (digitalData.page.attributes.initialPageLoadDidOccur) {
        // require.ensure is used to package nested requires in components.chunk.js
        // rather than priority.bundle.js in order to keep priority.bundle.js lean
        require.ensure([], function (require) {
            const certonaImpression = require('analytics/bindings/pages/all/certonaImpression');

            try {
                let isShown = savedRecsForAnalytics.resonance &&
                    savedRecsForAnalytics.resonance.schemes &&
                    savedRecsForAnalytics.resonance.schemes.length &&
                    savedRecsForAnalytics.resonance.schemes.filter(scheme => {
                        return scheme.display === 'yes';
                    });
                const orderDetails = store.getState().order.orderDetails;
                let isRopisOrder = orderDetails.header && orderDetails.header.isRopisOrder;

                if (isShown && !isRopisOrder) {
                    processEvent.process(
                        anaConsts.LINK_TRACKING_EVENT,
                        {
                            data: {
                                recs: savedRecsForAnalytics,
                                bindingMethods: [certonaImpression],
                                eventStrings: ['event71'],
                                specificEventName: anaConsts.EVENT_NAMES.CERTONA_IMPRESSION
                            }
                        },
                        { specificEventName: anaConsts.EVENT_NAMES.CERTONA_IMPRESSION }
                    );
                }
            } catch (e) {
                certonaUtils.fireCertonaFailed();
                console.error(`Exception processing link tracking event
                in Certona service: ${e}`);
            }
        }, 'components');
    }

    store.dispatch(updateCarousel(recs));
    certonaUtils.fireCertonaReady();
};

Events.onLastLoadEvent(window, [Events.UserInfoReady], () => {
    store.subscribe(
        watch(store.getState, 'user.profileId')(profileId => {
            certonaUtils.sendCertona(certonaConstants.CERTONA_EVENTS.USER_CHANGED, {
                customerId: profileId
            });
        }), { ignoreAutoUnsubscribe: true }
    );
});

const setupCertona = () => {
    /* Stop service from loading if not necessary */
    if (!shouldServiceRun.certona()) {
        return;
    }

    /**
     * Homepage setup for Certona
     * TODO: update environment check once BE sets up the flag
     */

    let currentLanguage =
        localeUtils.getCurrentLanguage().toUpperCase() === localeUtils.LANGUAGES.EN ?
            localeUtils.LANGUAGES.ENGLISH : localeUtils.LANGUAGES.FRENCH;

    window.certona = {
        pagetype: certonaUtils.getPageType(),
        country: localeUtils.getCurrentCountry().toUpperCase(),
        language: currentLanguage,
        device: Sephora.isDesktop() ? 'DESKTOP' : 'MOBILE'
    };

    if (certonaUtils.pageHasRecommendations()) {
        setCertonaObject('recommendations', true);
    }

    pageType = certonaUtils.getPageType();

    Promise.all([
        getCertona(),
        getBasket(),
        getProduct(),
        getUser(),
        getCategory(),
        getPurchase(),
        getContentPage(),
        getNullSearchTerm(),
        getLovesListPage(),
        getNthCategoryPage()
    ]).then(certonaUtils.initCertona);

};

module.exports = setupCertona;
